import CheckCircleFilled from "assets/icons/check-circle-filled.svg";
import NewStars from "assets/icons/new-stars.svg";
import DiscordIcon from "assets/icons/social/discord.icon";
import { Button, Modal, WhereverWidget } from "components";
import { useKeyWhereverWidget } from "config/wherever";
import { Colors, LocalStorage, SocialLinks } from "constants/constants";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StyledSubmissionSuccessModal } from "./styles";

type SubmissionSuccessModalProps = {
  isShowing: boolean;
  onHide?: () => void;
};

export function SubmissionSuccessModal({ isShowing, onHide }: SubmissionSuccessModalProps) {
  const { t } = useTranslation();
  const [showWhereverCTA, setShowWhereverCTA] = useState(localStorage.getItem(LocalStorage.ShowedWhereverCTA) !== "true");
  const whereverKey = useKeyWhereverWidget();

  const canShowWherever = showWhereverCTA && whereverKey;

  useEffect(() => {
    if (showWhereverCTA && isShowing) localStorage.setItem(LocalStorage.ShowedWhereverCTA, "true");
  }, [showWhereverCTA, isShowing]);

  return (
    <Modal isShowing={isShowing} onHide={onHide} overflowVisible>
      <StyledSubmissionSuccessModal>
        <img className="successIcon" src={CheckCircleFilled} alt="success" />
        <p className="title">{t("vulnerabilitySubmitted")}</p>

        {canShowWherever && (
          <div className="wherever-cta">
            <div className="new-flag">
              <img src={NewStars} alt="new" />
              <p>{t("new")}</p>
              <img src={NewStars} alt="new" />
            </div>
            <div className="title">{t("whereverModal.title")}</div>
            <div className="description">{t("whereverModal.description")}</div>

            <WhereverWidget type="subscribe" />
            <Button onClick={() => setShowWhereverCTA(false)} styleType="text">
              {t("skip")}
            </Button>
          </div>
        )}
        {!canShowWherever && (
          <div className="discord-cta">
            <Button onClick={() => window.open(SocialLinks.Discord)} styleType="filled">
              {t("joinUsDiscord")}
              <DiscordIcon fill={Colors.darkBlue} />
            </Button>
            <Button onClick={onHide} styleType="text" textColor="white">
              {t("skip")}
            </Button>
          </div>
        )}
      </StyledSubmissionSuccessModal>
    </Modal>
  );
}
